const Error = () => {
  return <div>Error</div>;
};

export { Error };
